// export default function Card({
//   header,
//   body,
//   label,
//   headerValue,
//   rightButtonLabel,
//   rightButtonHandler,
// }) {
//   return (
//     <div className="w-100">
//       <div className="d-flex w-100 justify-content-between align-items-center pt-3 mb-3">
//         {label ? (
//           <p className="text-primary m-0 fw-semibold">
//             {label}
//             {headerValue ? (
//               <span className="text-danger ps-1">({headerValue})</span>
//             ) : null}
//           </p>
//         ) : null}
//         {rightButtonLabel && rightButtonHandler ? (
//           <button
//             onClick={rightButtonHandler}
//             className="btn btn-link fw-medium"
//             style={{ fontSize: ".875rem" }}
//           >
//             {rightButtonLabel}
//           </button>
//         ) : null}
//       </div>
//       <div className="col w-100">
//         <div className="row bg-primary text-center pt-3 pb-3 rounded-top">
//           {header.map((item) => (
//             <div key={item} className="col text-white fw-semibold">
//               <p className="m-0 p-0" style={{ fontSize: ".9rem" }}>
//                 {item}
//               </p>
//             </div>
//           ))}
//         </div>

//         {body.length === 0 ? (
//           <div
//             className="row text-center pt-3 pb-3 rounded-bottom"
//             style={{
//               background: "white",
//               borderBottom: "1px solid rgba(0, 0, 0, .1)",
//             }}
//           >
//             <div className="col mt-4">
//               <p className="m-0 p-0" style={{ fontSize: ".9rem" }}>
//                 No access history.
//               </p>
//             </div>
//           </div>
//         ) : (
//           body.map((item, index) => (
//             <div
//               key={index}
//               className={`row text-center pt-3 pb-3 ${
//                 body.length - 1 === index ? "rounded-bottom" : ""
//               }`}
//               style={{
//                 background: "white",
//                 borderBottom: "1px solid rgba(0, 0, 0, .1)",
//               }}
//             >
//               {item.map((data, idx) => (
//                 <div key={idx} className="col">
//                   <p className="m-0 p-0" style={{ fontSize: ".9rem" }}>
//                     {data}
//                   </p>
//                 </div>
//               ))}
//             </div>
//           ))
//         )}
//       </div>
//     </div>
//   );
// }

import "./Card.css";

/**
 * Reusable table card.
 *
 * body: array of rows, where each row is an array of cell values (string | number | ReactNode)
 * Pass ReactNode cells (e.g. a <Badge/>) when a column needs custom styling —
 * Card itself stays presentation-only and doesn't need to know about your data's meaning.
 */
export default function Card({
  header,
  body,
  label,
  headerValue,
  rightButtonLabel,
  rightButtonHandler,
}) {
  return (
    <div className="card-block">
      <div className="card-block__top">
        {label ? (
          <p className="card-block__label">
            {label}
            {headerValue ? (
              <span className="card-block__label-value">({headerValue})</span>
            ) : null}
          </p>
        ) : null}

        {rightButtonLabel && rightButtonHandler ? (
          <button
            type="button"
            onClick={rightButtonHandler}
            className="card-block__view-all"
          >
            {rightButtonLabel}
            <span aria-hidden="true" className="card-block__chevron">
              &rsaquo;
            </span>
          </button>
        ) : null}
      </div>

      <div className="card-block__table-wrap">
        <table className="card-table">
          <thead>
            <tr>
              {header.map((item, idx) => (
                <th key={idx} scope="col">
                  {item}
                </th>
              ))}
            </tr>
          </thead>
          <tbody>
            {body.length === 0 ? (
              <tr>
                <td colSpan={header.length} className="card-table__empty">
                  No access history.
                </td>
              </tr>
            ) : (
              body.map((row, rIdx) => (
                <tr key={rIdx}>
                  {row.map((cell, cIdx) => (
                    <td key={cIdx}>{cell}</td>
                  ))}
                </tr>
              ))
            )}
          </tbody>
        </table>
      </div>
    </div>
  );
}

/**
 * Optional helper for Y/N style flag columns (e.g. LOCK).
 * Usage in the row builder:
 *   <Badge value={row.lock} trueLabel="Y" falseLabel="N" />
 */
export function Badge({ value, trueLabel = "Y", falseLabel = "N" }) {
  const isTrue = value === trueLabel;
  return (
    <span
      className={`card-badge ${isTrue ? "card-badge--danger" : "card-badge--neutral"}`}
    >
      {value ?? falseLabel}
    </span>
  );
}
